import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { Ingredient } from '../../common/Ingredients/types';
import { RootState } from '../../shared/store';

/**
 * The key is the `customerPortalMarketSegmentId` from the CountryMarketConfig
 */
export type IngredientsState = Partial<
  Record<
    string,
    {
      updatedAt: string;
      ingredients?: Ingredient[];
      error?: string;
    }
  >
>;

const initialState: IngredientsState = {};

export const state = createSlice({
  name: 'ingredientState',
  initialState,
  reducers: {
    resetAll: () => initialState,
    setIngredients: (
      ingredientsState: IngredientsState,
      {
        payload: { ingredients, countryMarket },
      }: PayloadAction<{
        ingredients: Ingredient[];
        countryMarket: string;
      }>,
    ) => {
      ingredientsState[countryMarket] = {
        ingredients,
        updatedAt: new Date().toISOString(),
      };
    },
    setIngredientsError: (
      ingredientsState: IngredientsState,
      {
        payload: { error, countryMarket },
      }: PayloadAction<{
        error: string;
        countryMarket: string;
      }>,
    ) => {
      ingredientsState[countryMarket] = {
        error,
        updatedAt: new Date().toISOString(),
      };
    },
  },
});

export const useIngredientsState = (): [
  IngredientsState,
  typeof state.actions,
] => [useSelector(({ ingredients }: RootState) => ingredients), state.actions];

export const actions = state.actions;

export const reducers = state.reducer;
